import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  shapeType: "平铺导航",
  value: "选中值",
  selectOptions: "平铺导航选项",
  bgColor: "背景颜色",
  bgIsThemeColor: "背景颜色主题色",
  borderStyle: "边框类型", // solid dashed dotted
  borderColor: "边框颜色",
  borderWidth: "边框宽度",
  borderIsThemeColor: "边框颜色为主题色",
  updateTimer: "数据轮询时间",
  restDataUrl: "外接数据源地址",
  showColNumber: "显示列数",
  widthList: "列宽度",
  changeWay: "切换方式",
  widthAuto: "宽度自适应", // 宽度 true:平均 false:自定义
  navWidth: "一级菜单宽度",
  lineMargin: "行间距",
  columnMargin: "列间距",

  "boxShadowColor.0": "阴影颜色1"
}
export const getOptDes = toSelectOpt.bind(this, optDes)
